// extracted by mini-css-extract-plugin
export default {"boxDisabled":"BoxDisabled_boxDisabled__T5q1q","boxContent":"BoxDisabled_boxContent__RtmMl"};